import styled from 'styled-components'

import { colors } from '../../styles/styleGuide'

export const Brand = styled.div`
  background-color: ${colors.purple};
  height: 100%;
  position: relative;
  width: 2.6em;
`

export const BrandLogo = styled.svg`
  color: ${colors.white};
  height: 1.7em;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`
export const MarkDoneButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: center;
  margin-left: 0.75rem;
`

export const Wrapper = styled.div.attrs(
  ({
    theme: {
      colorVars: { titleBar: styles },
    },
  }) => ({
    style: {
      height: `${styles.height}rem`,
    },
  }),
)`
  align-items: center;
  background-color: white;
  box-shadow: 0px -1.8em 0.7em 1.7em #000;
  display: flex;
  font-size: 1em;
  justify-content: space-between;
  user-select: none;
  z-index: 1;

  -webkit-user-select: none;
`

export const FullScreenButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: center;
  margin-left: 0.75rem;
  margin-right: 1.25rem;
`
